import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import CanView from "components/Common/CanView"
import { t } from "i18next"
import PackagesTable from "./components/PackagesTable"

function PackagesPage() {
  document.title = "packages | Pixamo"

  return (
    <CanView allowedUsers={["superuser"]} renderAuthFailed>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={t("home")} breadcrumbItem={t("packages")} />
          <PackagesTable />
        </Container>
      </div>
    </CanView>
  )
}

export default PackagesPage
